import React from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { sendGAPageview } from '../utils/gaConsent';
import CommonHeader from '../Components/Headers/CommonHeader';
import APIContent from '../Components/API/APIContent';
import Login from '../modules/login/Login';
import { userAppContext } from '../Context/Context';
import Modal from 'react-modal';
import $ from 'jquery';
import ApiHashLinks from '../Components/API/ApiHashiLinks';

export default function Api() {
  $('.popover').hide();

  const location = useLocation();
  const hash = location.hash;

  const { isAuthenticated, authError, setAuthError } = userAppContext();

  sendGAPageview({ hitType: 'pageview', page: '/Tools', title: 'Tools' });

  const customStyles = {
    content: {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-57%)',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '600px',
      background: 'transparent',
      boxSizing: 'border-box',
      border: null,
      padding: null,
    },
  };

  return isAuthenticated ? (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Our API and database tools</title>
        <meta
          name="description"
          content="DISGENET offers different tools to acces the database."
        />
        <meta property="og:title" content="DISGENET: Our API and database tools" />
        <meta
          property="og:description"
          content="Explore the various tools provided by DISGENET to access the database and enhance your research."
        />
        <meta property="og:url" content="https://www.disgenet.com/Tools" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/Tools" />
      </Helmet>
      <CommonHeader />
      <div className="container">
        <div className="row pt-4">
          <div className="col-12 col-md-3 order-0 order-md-0 mb-4 mb-md-0">
            <ApiHashLinks hash={hash} />
          </div>
          <div className="col-12 col-md-8 order-1 order-md-1">
            <APIContent />
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <>
      <Helmet>
        <title>DISGENET - Our Tools</title>
        <meta
          name="description"
          content="DISGENET offers different tools to acces the database."
        />
        <link rel="canonical" href="/Tools" />
      </Helmet>
      <CommonHeader />
      <Modal isOpen={true} ariaHideApp={false} style={customStyles} shouldFocusAfterRender={false}>
        {authError ? (
          <>
            <h1>Error: {authError}</h1>

            <div className="container-contact100-form-btn">
              <div className="wrap-contact100-form-btn">
                <div className="contact100-form-bgbtn" />
                <button
                  className="contact100-form-btn"
                  onClick={evt => {
                    setAuthError('');
                  }}
                >
                  Login
                </button>
              </div>{' '}
            </div>
          </>
        ) : (
          <Login />
        )}
      </Modal>
    </>
  );
}
